function parseLocation(locationValue) {
    const value = locationValue.split(',').map((l) => parseFloat(l));
    return { latitude: value[0], longitude: value[1] };
};
export default parseLocation;